<template>
  <v-content>
    <v-layout py-4 style="background-color: #3E7662;">
      <v-flex v-if="!nameTable" my-4>
        <span style="color: white;font-size: 24px">{{ nameTable }}</span>
      </v-flex>
      <v-flex v-if="nameTable">
        <span style="color: white;font-size: 24px">{{ nameTable }}</span>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
      </v-flex>
    </v-layout>
    <!-- Table -->
    <v-layout>
      <v-flex class="table">
        <v-data-table :headers="headers" :items="items" hide-default-footer>
          <!-- Back End คณะอนุกรรมการ_การจัดการงานวิจัย_งานวิจัยที่ผ่านการพิจารณา -->
          <!--                    <template v-if="onAlign" v-slot:item="{ item }">-->
          <!--                        <tr>-->
          <!--                            <td class="text-center">{{ item.number }}</td>-->
          <!--                            <td class="text-left">{{ item.SubcommitteeName }}</td>-->
          <!--                            <td class="text-center">-->
          <!--                                <v-icon color="#3E7662"-->
          <!--                                        style="color: #3E7662;cursor: pointer"-->
          <!--                                        @click="$router.push({name: 'ViewDataSubcommittee', query: { id: `${ item.id}`}})">-->
          <!--                                    visibility-->
          <!--                                </v-icon>-->
          <!--                            </td>-->
          <!--                        </tr>-->
          <!--                    </template>-->

          <template v-if="onViewData" v-slot:item="{ item }">
            <!-- Back End คณะอนุกรรมการ_การจัดการงานวิจัย_ดูข้อมูล (งานวิจัยทั้งหมด) ***AND*** Back End คณะอนุกรรมการ_การจัดการงานวิจัย_Post Approve -->
            <!-- For Research Approve -->


            <tr v-if="item.onView === 1" :style="item.status === 'ยังไม่ได้อ่าน'
              ? 'background: rgba(57, 137, 107, 0.23);'
              : ''
              ">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left">{{ item.nameResearch }}</td>
              <td class="text-center">{{ item.typeApprove }}</td>
              <td class="text-center">{{ item.joinMeeting }}</td>
              <td class="text-center">{{ item.sequence }}</td>
              <td class="text-center">{{ item.version }}</td>
              <td class="text-center">{{ item.status }}</td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onClickView1(item.researchID)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center"
                v-if="role === 3 && (item.typeApprove !== 'Full Board' || item.typeApprove !== 'Full Board (แก้ไขเพื่อรับรอง)')">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  :disabled="item.status === 'อ่านแล้ว' || item.isPast === 1" @click="
                    $router.push({
                      name: item.Evaluation,
                      query: {
                        id: `${item.id}`,
                        order: `${item.sequence}`,
                        nameResearch: `${item.nameResearch}`,
                        researchCode: `${item.researchCode}`,
                        mainResearcherFirstName: `${item.mainResearcherThName[0]}`,
                        mainResearcherLastName: `${item.mainResearcherThName[1]}`,
                        researchType: `${item.typeApprove}`,
                        reviewerName: `${item.reviewerName}`
                      },
                    })
                    ">
                  edit
                </v-icon>
              </td>
              <td class="text-center" v-else>
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
                  $router.push({
                    name: item.Evaluation,
                    query: {
                      id: `${item.id}`,
                      order: `${item.sequence}`,
                      nameResearch: `${item.nameResearch}`,
                      researchCode: `${item.researchCode}`,
                      mainResearcherFirstName: `${item.mainResearcherThName[0]}`,
                      mainResearcherLastName: `${item.mainResearcherThName[1]}`,
                      researchType: `${item.typeApprove}`,
                      reviewerName: `${item.reviewerName}`
                    },
                  })
                  ">
                  edit
                </v-icon>
              </td>
            </tr>

            <!-- For Post Approve -->
            <tr v-if="item.onView === 2" :bgcolor="item.nameReport === 0 ? '#daf7e1' : '#fff'">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left">{{ item.nameResearch }}</td>
              <td class="text-left">
                <div class="my-2" v-if="item.filter === '1'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF12',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                      },
                    })
                    ">
                    - แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย (RF 12_2563)
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
                <div class="my-2" v-if="item.filter === '2'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF04_2',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                      },
                    })
                    ">
                    - แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE) (RF 04_2_2563)
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
                <div class="my-2" v-if="item.filter === '3'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF05',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                      },
                    })
                    ">
                    - แบบรายงานการไม่ปฏิบัติตามข้อกำหนด (RF 05_2563)
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
                <div class="my-2" v-if="item.filter === '4'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF03',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                      },
                    })
                    ">
                    - แบบรายงานความก้าวหน้าของการวิจัย/ขอต่ออายุโครงการ (RF
                    03_2563)
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
                <div class="my-2" v-if="item.filter === '5'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF06',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                      },
                    })
                    ">
                    - แบบรายงานแจ้งปิด/สรุปผลการวิจัย (RF 06_2563)
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>

                <div class="my-2" v-if="item.filter === '7'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF07',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                      },
                    })
                    ">
                    - แบบรายงานการยุติโครงการวิจัยก่อนกําหนด (RF 07_2563)
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
                <div class="my-2" v-if="item.filter === '8'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF04_1',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                      },
                    })
                    ">
                    -
                    แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา
                    (RF 04_1_2563)
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
                <div class="my-2" v-if="item.filter === '6'">
                  <a @click="viewCorresFile(item)" target="_blank" style="color: #544a44;text-decoration: none">
                    <span class="view-report">
                      -เอกสารและจดหมายแจ้งเกี่ยวกับงานวิจัย (Correspondence Report)
                    </span>
                  </a>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
                <div class="my-2" v-if="item.filter === '9'">
                  <!-- {{item}} -->
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRFSusar',
                      query: {
                        id: item.idReport,
                        userID: item.userID,
                        rfID: item.id,
                        researchID: item.data.researchID,
                        status: item.data.status,
                        researchCode: item.data.researchCode,
                        firstName: item.data.firstName,
                        lastName: item.data.lastName,
                        nameResearch: item.data.researchName,
                        startReport: item.data.startReport,
                        hasUnexpectedEvents: item.data.hasUnexpectedEvents,
                        hasDDLetter: item.data.hasDDLetter,
                        hasSafetyReport: item.data.hasSafetyReport,
                        hasMoreReport: item.data.hasMoreReport,
                        thName: item.data.signature,
                      },
                    })
                    ">
                    -
                    แบบรายงานเหตุการณ์ไม่พึ่งประสงค์นอกสถาบัน SUSAR / DMC / DSMB
                  </span>
                  <span v-if="item.nameReport === 0" style="color: #CC3D45">ยังไม่ได้อ่าน</span>
                  <span v-if="item.nameReport === 1" style="color: #3E7662">อ่านแล้ว</span>
                </div>
              </td>
              <td class="text-center">{{ item.groupID }}</td>
              <td class="text-center">
                <v-icon :disabled="!item.data.toReviewerFiles ||
                  !item.data.toReviewerFiles[0].file
                  " color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onViewToReviewerFiles(item.data)">
                  visibility
                </v-icon>
              </td>

              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  @click="onClickView2(item.researchID, item.userID)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center" v-if="item.filter == 8">
                {{ item.research_pass }}
              </td>
              <td class="text-center" v-else>
                {{ item.researchCode }}
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  @click="onClicktoViewDocument(item.researchID, item.userID, item.filter)">
                  visibility
                </v-icon>
              </td>

              <td class="text-center">
                <v-icon :disabled="item.nameReport === 1 && item.role === 3" color="#3E7662"
                  style="color: #3E7662;cursor: pointer" @click="
                    $router.push({
                      name: item.evaluation,
                      query: {
                        read: 0,
                        id: `${item.researchID}`,
                        rfID: `${item.rfID}`,
                        rfType: `${item.rfType}`,
                        filter: item.filter,
                        researchName: item.data.researchName,
                        researcher: item.data.researcher,
                        researchCode: item.data.researchCode,
                        researchCodeRo07: item.data.research.researchCode,
                        mainResearcher: item.data.mainResearcher,
                        firstName: item.data.firstName,
                        lastName: item.data.lastName,
                        fname: item.data.fname,
                        lname: item.data.lname,
                        mobilePhone: item.data.mobilePhone,
                        researcherName: item.data.researcherName,
                        approvalDate: item.data.research.approvalDate,
                        approvalExpireDate:
                          item.data.research.approvalExpireDate ? item.data.research.approvalExpireDate : item.data.research.endDate,
                        sendReportDate: item.data.reportDate,
                        sendReportTime: item.data.reportTime,

                        accrualCeiling: item.data.accrualCeiling,
                        totalParticipants: item.data.totalParticipants,
                        totalScreening: item.data.totalScreening,
                        totalWithdrawn: item.data.totalWithdrawn,
                        totalDead: item.data.totalDead,
                        totalCompleteResearch: item.data.totalCompleteResearch,
                        totalExpAdversEvents: item.data.totalExpAdversEvents,
                        totalExpSUSARs: item.data.totalExpSUSARs,
                        totalGlobal: item.data.totalGlobal,

                        hasIssue: item.data.hasIssue,
                        hasWarning: item.data.hasWarning,
                        hasImpact: item.data.hasImpact,
                        anyProtocolFile: item.data.anyProtocolFile,
                        anyComplaintFile: item.data.anyComplaintFile,

                        isFollowUp: item.data.hasFollowUp,
                        followUp: item.data.followUp,
                        isPlan: item.data.hasPlan,
                        plan: item.data.plan,

                        checkbox1: item.data.hasDeviation,
                        checkbox2: item.data.hasProtocol,
                        has1: item.data.hasRandom,
                        event1: item.data.randomEventNumber,
                        has2: item.data.hasEnrollment,
                        event2: item.data.enrollmentEventNumber,
                        has3: item.data.hasNotScreening,
                        event3: item.data.notScreeningEventNumber,
                        has4: item.data.hasFailureTherapy,
                        event4: item.data.failureTherapyEventNumber,
                        has5: item.data.hasFailureAccomplish,
                        event5: item.data.failureAccomplishEventNumber,
                        has6: item.data.hasScreening,
                        event6: item.data.screeningEventNumber,
                        has8: item.data.hasFollowUp,
                        event8: item.data.followUpEventNumber,
                        has7: item.data.hasOther1,
                        event7: item.data.other1,
                        checkbox3: item.data.hasNonCompliance,
                        has9: item.data.hasDelaySAEReport,
                        event9: item.data.delaySAEReportEventNumber,
                        has10: item.data.hasDelayContinuingReport,
                        event10: item.data.delayContinuingReportEventNumber,
                        has11: item.data.hasUseUnstampedInformed,
                        event11: item.data.useUnstampedInformedEventNumber,
                        has12: item.data.hasAccountabilityDrug,
                        event12: item.data.accountabilityDrugEventNumber,
                        has13: item.data.hasOther2,
                        event13: item.data.other2,
                        totalOfReport: item.data.totalOfReport,
                        totalOfVolunteer: item.data.totalOfVolunteer,
                      },
                    })
                    ">
                  edit
                </v-icon>
              </td>
            </tr>

            <!-- Back End เลขานุการ_การจัดการงานวิจัย_โครงการวิจัยที่ได้รับพิจารณาแล้ว -->
            <tr v-if="item.onView === 3" :bgcolor="!item.considerType ? '#daf7e1' : '#fff'">
              <td class="text-center" width="3%">{{ item.number }}</td>
              <td class="text-left pa-2" width="35%" style="word-break: break-all;">
                {{
                  item.researchName.length > 200
                  ? item.researchName.slice(0, 200) + "....."
                  : item.researchName
                }}
              </td>
              <!-- <td class="text-left">{{ item.researchName }}</td> -->
              <td class="text-left" width="20%">{{ item.researcherName }}</td>
              <td class="text-center" width="8%">{{ item.version }}</td>
              <td class="text-center" width="8%">
                {{ item.considerTypeShow }}
              </td>
              <td class="text-left" width="8%">{{ item.initial }}</td>
              <td class="text-center" width="8%">{{ item.code }}</td>
              <td class="text-center" width="8%">
                <v-icon :disabled="!item.checkResearcherTypeID || item.checkMailSend" color="#3E7662"
                  style="color: #3E7662;cursor: pointer" @click="typeConsideration(item)">
                  edit
                </v-icon>
              </td>
              <td class="text-center" width="5%">
                <v-icon :disabled="item.considerType === 3 ||
                  item.considerType === null ||
                  item.checkMailSend
                  " :color="item.checkColor ? '#3E7662' : '#CC3D45'" style="cursor: pointer" @click="
    $router.push({
      name: 'SelectSubcommitteeForm',
      query: {
        id: `${item.id}`,
        oldVersionConsiderResult: `${item.oldVersionConsiderResult}`,
        considerType: `${item.considerType}`,
        isResubmission: `${item.isResubmission}`
      },
    })
    ">
                  edit
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon :disabled="!item.checkColor || item.checkMailSend" color="#3E7662" style="cursor: pointer"
                  @click="onSendMail(item.id)">
                  email
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  @click="onClickViewVerifiedResearch(item.id)">
                  visibility
                </v-icon>
              </td>
            </tr>

            <!-- For President -->
            <tr v-if="item.onView === 4" :bgcolor="item.status ? '#daf7e1' : '#fff'">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left">{{ item.nameResearch }}</td>
              <td class="text-center">{{ item.nameResearcher }}</td>
              <td class="text-center">{{ item.researchCode }}</td>
              <td class="text-center">{{ item.considerType }}</td>
              <td class="text-center">{{ item.version }}</td>
              <td class="text-center">{{ item.considerResult }}</td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onClickView4(item.researchID)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onApprove(item)"
                  :disabled="!item.status">
                  edit
                </v-icon>
              </td>
              <td class="text-center" v-if="!item.isSendApproveMail">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onMailSend(item)"
                  :disabled="item.status || item.isSendApproveMail">
                  email
                </v-icon>
              </td>
              <td class="text-center" v-else>
                <a color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onMailResend(item.researchID)">
                  ส่งซ้ำ,
                </a>
                <br>
                <a :href="item.mailLink" target="_blank" style="color: #3E7662;cursor: pointer;text-decoration: none"
                  :disabled="!item.isSendApproveMail">
                  ดูอีเมล
                </a>
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onMailSend(item)">
                  edit
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" :disabled="item.status"
                  @click="downloadPDF(item, 'researchApprove')">
                  save_alt
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onApproveRegen(item)"
                  :disabled="item.status">
                  refresh
                </v-icon>
              </td>
            </tr>

            <tr v-if="item.onView === 5">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left" width="30%">{{ item.topicNews }}</td>
              <td class="text-left" width="30%">{{ item.detail }}</td>
              <td class="text-center" width="20%">{{ item.date }}</td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
                  $router.push({
                    name: `${item.linkEdit}`,
                    query: { id: `${item.id}` },
                  })
                  ">
                  edit
                </v-icon>
              </td>
            </tr>

            <tr v-if="item.onView === 6">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left" width="30%">{{ item.partyName }}</td>
              <td class="text-left" width="30%">{{ item.partyNameEN }}</td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="editParty(item)">
                  edit
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#CC3D45" style="cursor: pointer" @click="delParty(item.id)">
                  delete
                </v-icon>
              </td>
            </tr>

            <!-- Table Verify Form RF -->
            <tr v-if="item.onView === 7">
              <!-- {{item}} -->
              <td class="text-center">{{ item.number }}</td>
              <td class="text-center">{{ item.nameResearch }}</td>
              <td class="text-center" v-if="item.filterType == 8"> {{ item.researcherName2 }} </td>
              <td class="text-center" v-else-if="item.filterType == 7"> {{ item.researcherName4 }} </td>
              <td class="text-center" v-else-if="item.filterType == 5"> {{ item.researcherName4 }} </td>
              <td class="text-center" v-else-if="item.filterType == 6"> {{ item.researcherName3 }} </td>
              <td class="text-center" v-else> {{ item.researcherName }} </td>
              <td class="text-center">{{ item.version }}</td>
              <td class="text-center">{{ item.groupID }}</td>
              <td class="text-center">{{ item.editStatus }}</td>
              <td class="text-center" v-if="item.filterType != 6 && item.filterType != 9">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  @click="onClickView7(item.researchID, item.linkEdit, item.id)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center" v-if="item.filterType == 9">
                <!-- {{item.item}} -->
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
                  $router.push({
                    name: 'ViewFormRFSusar',
                    query: {
                      rfID: item.id,
                      researchID: item.item.researchID,
                      status: item.item.status,
                      researchCode: item.item.researchCode,
                      firstName: item.item.firstName,
                      lastName: item.item.lastName,
                      nameResearch: item.item.researchName,
                      startReport: item.item.startReport,
                      hasUnexpectedEvents: item.item.hasUnexpectedEvents,
                      hasDDLetter: item.item.hasDDLetter,
                      hasSafetyReport: item.item.hasSafetyReport,
                      hasMoreReport: item.item.hasMoreReport,
                      thName: item.item.signature
                    },
                  })">
                  visibility
                </v-icon>
              </td>
              <td class="text-center" v-if="item.filterType == 6">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="viewCorresFile(item)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center">
                <div v-if="item.editStatus == 'รอนักวิจัยแก้ไข'">
                  <v-icon color="#3E7662" style="cursor: pointer" @click="editCheckRF(item)" disabled>
                    check_circle
                  </v-icon>
                </div>
                <div v-else>
                  <v-icon color="#3E7662" style="cursor: pointer" @click="editCheckRF(item)">
                    check_circle
                  </v-icon>
                </div>
              </td>
              <td class="text-certer" v-if="item.filterType == 8">
                {{ item.research_pass }}
              </td>
              <td class="text-center" v-else>
                {{ item.researchCode }}
              </td>
              <td class="text-center">
                <v-icon color="red" style="cursor: pointer" @click="deleteRF(item)">
                  cancel
                </v-icon>
              </td>
            </tr>

            <!-- Table Approve Form RF -->
            <tr v-if="item.onView === 8" :bgcolor="item.status !== 'อนุมัติ' ? '#daf7e1' : '#fff'">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left" width="30%">{{ item.nameResearch }}</td>
              <td class="text-center">{{ item.researchCode }}</td>
              <td class="text-center">{{ item.groupID }}</td>
              <td class="text-center">{{ item.status }}</td>
              <td class="text-center" v-if="item.filterType != 6">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  @click="onClickView8(item.researchID, item.linkEdit, item.id)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center" v-else>
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="viewCorresFile(item)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="cursor: pointer" :disabled="item.status === 'อนุมัติ'"
                  @click="onApproveRF(item.item)">
                  edit
                </v-icon>
              </td>
              <td class="text-center" v-if="!item.isSendApproveMail">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  :disabled="item.status !== 'อนุมัติ' || item.isSendApproveMail" @click="onMailSend(item)">
                  email
                </v-icon>
              </td>
              <td class="text-center" v-else>
                <a color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onMailResend(item.researchID)">
                  ส่งซ้ำ,
                </a>
                <br>
                <a :href="item.mailLink" target="_blank" style="color: #3E7662;cursor: pointer;text-decoration: none"
                  :disabled="!item.isSendApproveMail">
                  ดูอีเมล
                </a>
                <v-icon color="#3E7662" style="cursor: pointer" @click="onMailSend(item)">
                  edit
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" :disabled="item.status !== 'อนุมัติ'"
                  @click="downloadPDF(item, 'postApprove')">
                  save_alt
                </v-icon>
              </td>
              <!-- <td class="text-center">{{ item.researchCode }}</td> -->
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onApproveRegen(item)"
                  :disabled="item.status !== 'อนุมัติ'">
                  refresh
                </v-icon>
              </td>
            </tr>

            <!-- Table Verify Form RF -->
            <tr v-if="item.onView === 9" :bgcolor="item.status === 'อยู่ระหว่างการพิจารณา' ? '#daf7e1' : '#fff'
              ">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left">{{ item.nameResearch }}</td>
              <td class="text-left">{{ item.researchCode }}</td>
              <td class="text-left">{{ item.researcherName }}</td>
              <td class="text-center">{{ item.group_id }}</td>
              <td class="text-center">{{ item.version }}</td>
              <td class="text-center">{{ item.status }}</td>
              <td class="text-center">{{ item.initial }}</td>
              <td class="text-center" v-if="item.filterType != 6 && item.filterType != 9">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer"
                  @click="onClickView9(item.researchID, item.linkEdit, item.id)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center" v-if="item.filterType == 6">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="viewCorresFile(item)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center" v-if="item.filterType == 9">
                <!-- {{item.item}} -->
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
                  $router.push({
                    name: 'ViewFormRFSusar',
                    query: {
                      rfID: item.id,
                      researchID: item.item.researchID,
                      status: item.item.status,
                      researchCode: item.item.researchCode,
                      firstName: item.item.firstName,
                      lastName: item.item.lastName,
                      nameResearch: item.item.researchName,
                      startReport: item.item.startReport,
                      hasUnexpectedEvents: item.item.hasUnexpectedEvents,
                      hasDDLetter: item.item.hasDDLetter,
                      hasSafetyReport: item.item.hasSafetyReport,
                      hasMoreReport: item.item.hasMoreReport,
                      thName: item.item.signature
                    },
                  })">
                  visibility
                </v-icon>
              </td>
              <!-- ดูเอกสารประเมิน -->
              <td class="text-center">
                <!-- <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" :disabled="item.isRead !== 1"
                  @click=" $router.push({ name: item.evaluation, query: { id: item.researchID, read: 1, rfID: item.rfID }, })">
                  visibility
                </v-icon> -->
                <span v-if="item.isRead !== 1"> {{ item.item.reviewer.thFirstName + " " +
                  item.item.reviewer.thLastName }} </span>
                <a v-else v-on="on"
                  @click=" $router.push({ name: item.evaluation, query: { id: item.researchID, read: 1, rfID: item.rfID, rfType: item.linkEdit }, })"
                  target="_blank" style="color: #3e7662">{{ item.item.reviewer.thFirstName + " " +
                    item.item.reviewer.thLastName }}</a>
              </td>
              <td class="text-center">
                <v-icon :disabled="item.status !== 'อยู่ระหว่างการพิจารณา' || item.isRead !== 1" color="#3E7662"
                  style="cursor: pointer" @click="verifyRF(item.item)">
                  edit
                </v-icon>
              </td>
            </tr>

            <!-- Table Research All -->
            <tr v-if="item.onView === 10" :bgcolor="item.code !== '-' && item.status === 'อยู่ระหว่างการพิจารณา'
              ? '#daf7e1'
              : '#fff'
              ">
              <td class="text-center" width="3%">{{ item.number }}</td>
              <td class="text-left pa-2" width="30%" style="word-break: break-all;">
                {{
                  item.researchName.length > 200
                  ? item.researchName.slice(0, 200) + "....."
                  : item.researchName
                }}
              </td>
              <td class="text-center" width="20%">{{ item.researcherName }}</td>
              <td class="text-center" width="8%">{{ item.approvalDate }}</td>
              <td class="text-center" width="8%">
                {{ item.status }}<br>
                Version({{ item.version }})
              </td>
              <td class="text-center" width="12%">
                {{ item.initial }}<br>
                {{ item.code }}<br>
                {{ item.type }}<br>
                {{ item.ymidname == null || item.ymidname == "null" ? "-" : item.ymidname }}
              </td>
              <td v-if="item.type != 'Exemption'" class="text-center" width="20%">
                <span v-if="!item.isOrder1 && !item.isOrder2 && !item.isOrder3"> - </span>
                <div v-if="item.order1 !== ''">
                  <a v-on="on" :href="item.order1" target="_blank" style="color: #3e7662">{{ item.isOrder1 }} (1)</a>
                </div>
                <div v-else-if="item.isOrder1 != 0"><span style="color: darkgray" v-on="on">{{ item.isOrder1 }} (1)</span>
                </div>
                <br />
                <div v-if="item.order2 !== ''">
                  <a v-on="on" :href="item.order2" target="_blank" style="color: #3e7662">{{ item.isOrder2 }} (2)</a>
                </div>
                <div v-else-if="item.isOrder2 != 0"><span style="color: darkgray" v-on="on">{{ item.isOrder2 }} (2)</span>
                </div>
                <br />
                <div v-if="item.order3 !== ''">
                  <a v-on="on" :href="item.order3" target="_blank" style="color: #3e7662">{{ item.isOrder3 }} (3)</a>
                </div>
                <div v-else-if="item.isOrder3 != 0"><span style="color: darkgray" v-on="on">{{ item.isOrder3 }} (3)</span>
                </div>
              </td>
              <td v-else-if="item.type == 'Exemption'" class="text-center" width="20%">
                <div v-if="item.ro03_4FilePath">
                  <a v-on="on" :href="item.ro03_4FilePath" target="_blank" style="color: #3e7662">แบบประเมิน (RO 03_4)</a>
                </div>
                <div v-else style="color: darkgray">แบบประเมิน (RO 03_4)</div>
              </td>
              <td v-else class="text-center" width="20%">
                -
              </td>
              <td class="text-center" width="5%">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onClickAllResearch(item.id)">
                  visibility
                </v-icon>
              </td>
              <td class="text-center" width="5%">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onClickResearchHistory(item.id)">
                  history
                </v-icon>
              </td>
              <td class="text-center" width="5%">
                <div
                  v-if="!['อนุมัติ', 'ผ่านการพิจารณา', 'ปรับปรุงแก้ไขเพื่อรับรอง', 'ปรับปรุงแก้ไขเพื่อพิจารณาใหม่', 'เสร็จสิ้น', 'ไม่รับรอง หรือ ไม่อนุมัติ'].includes(item.status)">
                  <v-icon :disabled="item.code === '-' || item.status !== 'อยู่ระหว่างการพิจารณา' || item.readStatus"
                    color="#3E7662" style="color: #3E7662;cursor: pointer" @click="editConsiderResult(item)">
                    edit
                  </v-icon>
                </div>
                <div v-else>
                  <a color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onMailResend(item.id)">
                    ส่งซ้ำ,
                  </a>
                  <br>
                  <a :href="item.mailLink" target="_blank" style="color: #3E7662;cursor: pointer;text-decoration: none">
                    ดูอีเมล
                  </a>
                  <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="editConsiderResult(item)">
                    edit
                  </v-icon>
                </div>
              </td>

              <td class="text-center" width="5%">
                <v-icon :disabled="item.type === '-' || item.status !== 'อยู่ระหว่างการพิจารณา'
                  " color="red" style="color: #3E7662;cursor: pointer" @click="cancelResearchCode(item)">
                  cancel
                </v-icon>
              </td>
            </tr>

            <!-- Tables Cannel -->
            <tr v-if="item.onView === 15" :bgcolor="item.status === 'รอดำเนินขอยกเลิกโครงการ'
              ? '#daf7e1'
              : '#fff'
              ">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-center" width="20%">{{ item.researchname }}</td>
              <td class="text-center" width="20%">{{ item.researchername }}</td>
              <td class="text-center" width="25%">{{ item.status }}</td>
              <td class="text-center">
                {{ item.initial }}<br>
                {{ item.researchCode }}
              </td>
              <td class="text-center" width="10%">{{ item.signDate }}</td>
              <td class="text-center" v-if="item.status == 'งานวิจัยที่ปิดโครงการ'">
                <v-icon color="#3E7662" style="color: #e3E3e3e3;">
                  library_add_check
                </v-icon>
              </td>
              <td class="text-center" v-else>
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="acceptCancel(item)">
                  library_add_check
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #e3E3e3e3" v-if="!item.pdf">
                  visibility
                </v-icon>
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="viewDatacancel(item)" v-else>
                  visibility
                </v-icon>
              </td>
            </tr>
            <tr v-if="item.onView === 16">
              <td class="text-center">
                <div class="my-2" v-if="item.filterType === '1'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF12',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                        groupID: `${item.groupID}`,
                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
                <div class="my-2" v-if="item.filterType === '2'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF04_2',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                        groupID: `${item.groupID}`,
                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
                <div class="my-2" v-if="item.filterType === '3'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF05',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                        groupID: `${item.groupID}`,
                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
                <div class="my-2" v-if="item.filterType === '4'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF03',
                      query: {
                        id: `${item.idReport}`,
                        userID: `${item.userID}`,
                        groupID: `${item.groupID}`,
                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
                <div class="my-2" v-if="item.filterType === '5'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF06',
                      query: {
                        id: `${item.idReport}`,
                        userID: `${item.userID}`,
                        groupID: `${item.groupID}`,
                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
                <div class="my-2" v-if="item.filterType === '7'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF07',
                      query: {
                        id: `${item.idReport}`,
                        userID: `${item.userID}`,
                        groupID: `${item.groupID}`,
                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
                <div class="my-2" v-if="item.filterType === '8'">
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRF04_1',
                      query: {
                        id: `${item.idReport}`,
                        rfID: `${item.rfID}`,
                        userID: `${item.userID}`,
                        groupID: `${item.groupID}`,
                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
                <div class="my-2" v-if="item.filter === '6'">
                  <a @click="viewCorresFile(item)" target="_blank" style="color: #544a44;text-decoration: none">
                    <span class="view-report">
                      {{ item.nameResearch }}
                    </span>
                  </a>
                </div>
                <div class="my-2" v-if="item.filterType === '9'">
                  <!-- {{item}} -->
                  <span class="view-report" @click="
                    $router.push({
                      name: 'ViewFormRFSusar',
                      query: {
                        id: item.idReport,
                        userID: item.userID,
                        rfID: item.id,
                        researchID: item.researchID,
                        status: item.status,
                        researchCode: item.researchCode,
                        firstName: item.firstName,
                        lastName: item.lastName,
                        nameResearch: item.researchName,
                        startReport: item.startReport,
                        hasUnexpectedEvents: item.hasUnexpectedEvents,
                        hasDDLetter: item.hasDDLetter,
                        hasSafetyReport: item.hasSafetyReport,
                        hasMoreReport: item.hasMoreReport,
                        thName: item.signature,
                        groupID: item.groupID

                      },
                    })
                    ">{{ item.nameResearch }}
                  </span>
                </div>
              </td>
              <td class="text-center">{{ item.groupID }}</td>
              <td class="text-center">{{ item.actionat }}</td>
            </tr>

            <!-- Table New Research -->
            <tr v-if="item.onView === 11" 
            :bgcolor="item.initial === '-' && item.status === 'รอดำเนินการ' && (item.editStatus === '-' || item.editStatus === 'แก้ไขเสร็จสิ้น')
              ? '#daf7e1'
              : '#fff'
              ">
              <td class="text-center" width="2%">{{ item.number }}</td>
              <td class="text-left pa-2" width="35%" style="word-break: break-all;">
                {{
                  item.researchName.length > 200
                  ? item.researchName.slice(0, 200) + "....."
                  : item.researchName
                }}
              </td>
              <td class="text-center" width="20%">{{ item.researcherName }}</td>
              <td class="text-center" width="8%">{{ item.status }}</td>
              <td class="text-center" width="8%">{{ item.editStatus }}</td>
              <td class="text-center" width="8%">{{ item.initial }}</td>
              <td class="text-center" width="10%">{{ item.submissionType }}</td>
              <td class="text-center" width="10%">{{ item.sendDate }}</td>
              <td class="text-center" width="5%">
                <v-icon :disabled="(item.status === 'อยู่ระหว่างการพิจารณา' &&
                  item.initial !== '-') ||
                  item.editStatus === 'รอนักวิจัยแก้ไข'
                  " color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
                  $router.push({
                    name: `${item.linkCheck}`,
                    params: {
                      id: item.id,
                      researchName: item.researchName,
                      researcherName: item.researcherName,
                      researcherMobile: item.researcherMobile,
                      coordinatorName: item.coordinatorName,
                      coordinatorMobile: item.coordinatorMobile,
                      researcherAffiliation: item.researcherAffiliation,
                      from: 'researchAll',
                    },
                  })
                  ">
                  library_add_check
                </v-icon>
              </td>
              <td class="text-center" width="5%">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onClickNewResearch(item.id)">
                  visibility
                </v-icon>
              </td>
            </tr>

            <!-- Table User Management -->
            <tr v-if="item.onView === 12">
              <!--<tr v-if="item.onView === 12" :bgcolor="item.researcherTypeID === '-' ? '#daf7e1' : '#fff'">-->
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-center">{{ item.position }}</td>
              <td class="text-center">{{ item.organize }}</td>
              <td class="text-center">
                <!-- <a :href="'http://service.irbrta-research.com/api/redirect-force-login?email=' + item.email"
                  target="_blank">
                  <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer">
                    mdi-account
                  </v-icon>
                </a> -->
                <!-- <a :href="'http://localhost:8000/api/redirect-force-login?email=' + item.email"
                  target="_blank">
                  <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer">
                    mdi-account
                  </v-icon>
                </a> -->
                <a :href="domain()+'/api/redirect-force-login?email=' + item.email"
                  target="_blank">
                  <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer">
                    mdi-account
                  </v-icon>
                </a>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
                  $router.push({
                    name: `${item.linkView}`,
                    query: { id: `${item.id}`, type: 'u' },
                  })
                  ">
                  visibility
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="onModal(item.id, item.remark)">
                  edit
                </v-icon>
              </td>
            </tr>

            <tr v-if="item.onView === 14" :bgcolor="item.isReviewer === 1 && item.reviewerApprove === 0
              ? '#daf7e1'
              : '#fff'
              ">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left">{{ item.name }}</td>
              <!--                            <td class="text-center">{{ item.position }}</td>-->
              <!--                            <td class="text-center">{{ item.organize }}</td>-->
              <td class="text-center">{{ item.user_type }}</td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
                  $router.push({
                    name: `${item.linkView}`,
                    query: { id: `${item.id}`, type: 'a' },
                  })
                  ">
                  visibility
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="EditUser(item.id)">
                  edit
                </v-icon>
              </td>
              <td class="text-center">
                <v-icon :disabled="!(item.isReviewer === 1 && item.reviewerApprove === 0)
                  " color="#3E7662" style="color: #3E7662;cursor: pointer" @click="VerifyReviewer(item.id)">
                  library_add_check
                </v-icon>
              </td>
            </tr>


            <!-- Table Certificate Management -->
            <tr v-if="item.onView === 13" :bgcolor="item.status === 'รอการพิจารณา'
              ? '#daf7e1'
              : '#fff' && item.status === 'ไม่อนุมัติ'
                ? '#fae8e8'
                : '#fff'
              ">
              <td class="text-center">{{ item.number }}</td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-center">{{ item.createDate }}</td>
              <td class="text-center">{{ item.sendDate }}</td>
              <td class="text-center">{{ item.dayRemaining }}</td>
              <td class="text-center">{{ item.status }}</td>
              <td class="text-center">
                <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="viewCer(item.viewCer)">
                  visibility
                </v-icon>
              </td>
              <!--                  :disabled="item.status === 'อนุมัติ'"-->
              <!--                  :color="-->
              <!--                    item.status === 'รอการพิจารณา' ? '#3E7662' : '#a8a8a8'-->
              <!--                  "-->
              <td class="text-center">
                <v-icon color="#3E7662" style="cursor: pointer" @click="viewCertificate(item)">
                  library_add_check
                </v-icon>
              </td>
            </tr>


          </template>

          <template v-if="onEditBudget" v-slot:item.editBudget="{ item }">
            <v-icon color="#3E7662" @click="editBudget(item)">edit</v-icon>
          </template>

          <template v-if="onDelete" v-slot:item.delete="{ item }">
            <span style="color: #CC3D45;cursor: pointer" @click="onClickDelete(item.deleteUser)">
              <v-icon color="#CC3D45">delete</v-icon>
            </span>
          </template>

          <template v-if="onDelete" v-slot:item.delete="{ item }">
            <span style="color: #CC3D45;cursor: pointer" @click="onClickDelete(item.deleteRF)">
              <v-icon color="#CC3D45">delete</v-icon>
            </span>
          </template>

          <template v-if="onDeleteBudget" v-slot:item.deleteBudget="{ item }">
            <span style="color: #CC3D45;cursor: pointer" @click="onClickDeleteBudget(item.deleteBudget)">
              <v-icon color="#CC3D45">delete</v-icon>
            </span>
          </template>

          <template v-if="onDeleteBudget" v-slot:item.deleteBudget="{ item }">
            <span style="color: #CC3D45;cursor: pointer" @click="onClickDeleteBudget(item.deleteBudget)">
              <v-icon color="#CC3D45">delete</v-icon>
            </span>
          </template>

          <template v-if="onCheck" v-slot:item.check="{ item }">
            <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
              $router.push({
                name: `${item.linkCheck}`,
                query: { id: `${item.id}` },
              })
              ">
              library_add_check
            </v-icon>
          </template>

          <template v-if="onView" v-slot:item.view="{ item }">
            <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
              $router.push({
                name: `${item.linkView}`,
                query: { id: `${item.id}` },
              })
              ">
              <!--                                @click="$router.push({name: `${item.linkView}`, query: { id: `${item.id}`, from:`${item.form}`}})">-->
              visibility
            </v-icon>
          </template>

          <template v-if="typeSubcommittee" v-slot:item.view="{ item }">
            <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
              $router.push({
                name: `${item.linkView}`,
                query: { id: `${item.id}` },
              })
              " :disabled="user.id != item.id && role === 3">
              visibility
            </v-icon>
          </template>

          <template v-if="onEditResearch" v-slot:item.edit="{ item }">
            <v-icon :disabled="item.code === '-'
              ? true
              : false || item.status === 'อนุมัติ'
                ? true
                : false || item.status === 'ผ่านการพิจารณา'
                  ? true
                  : false
              " color="#3E7662" style="color: #3E7662;cursor: pointer" @click="editConsiderResult(item)">
              edit
            </v-icon>
          </template>

          <template v-if="onEditMeeting" v-slot:item.edit_meeting="{ item }">
            <v-icon :disabled="item.currentRole === 3" color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
              $router.push({
                name: `${item.linkEdit}`,
                query: { id: `${item.id}` },
              })
              ">
              edit
            </v-icon>
          </template>

          <template v-if="onEditSubMeeting" v-slot:item.edit_submeeting="{ item }">
            <v-icon color="#3E7662" :disabled="item.isSend == 1 || item.currentRole === 3"
              style="color: #3E7662;cursor: pointer" @click="
                $router.push({
                  name: `${item.linkEdit}`,
                  query: { id: `${item.id}` },
                })
                ">
              edit
            </v-icon>
          </template>

          <template v-if="onViewDataSubMeeting" v-slot:item.view_submeeting="{ item }">
            <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
              $router.push({
                name: `${item.linkView}`,
                query: { id: `${item.id}` },
              })
              ">
              visibility
            </v-icon>
          </template>

          <template v-if="onViewMeeting" v-slot:item.view_meeting="{ item }">
            <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="
              $router.push({
                name: `${item.linkView}`,
                query: { id: `${item.id}` },
              })
              ">
              visibility
            </v-icon>
          </template>

          <!--                    <template v-if="onViewCertificate" v-slot:item.viewCer="{ item }">-->
          <!--                        <v-icon color="#3E7662"-->
          <!--                                style="color: #3E7662;cursor: pointer"-->
          <!--                                @click="viewCer(item.viewCer)">-->
          <!--                            visibility-->
          <!--                        </v-icon>-->
          <!--                    </template>-->

          <!--                    <template v-if="onCheckCertificate" v-slot:item.checkCer="{ item }">-->
          <!--                        <v-icon color="#3E7662"-->
          <!--                                style="color: #3E7662;cursor: pointer"-->
          <!--                                @click="viewCertificate(item)">-->
          <!--                            library_add_check-->
          <!--                        </v-icon>-->
          <!--                    </template>-->

          <template v-if="onCheckUser" v-slot:item.checkUser="{ item }">
            <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" @click="viewUser(item)">
              library_add_check
            </v-icon>
          </template>

          <template v-if="onChangeStatus" v-slot:item.editMeeting="{ item }">
            <v-icon color="#3E7662" style="color: #3E7662;cursor: pointer" :disabled="item.remainingDay == 0"
              @click="changeStatusMeeting(item)">
              edit
            </v-icon>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-divider style="background-color: #544A44;border-width: 2px"></v-divider>
      </v-flex>
    </v-layout>

    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapActions, mapState } from "vuex";
import { domain } from '../../services/Constants'

export default {
  name: "FormTable",
  components: {
    Loading,
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      role: (state) => state.Auth.role,
    }),
  },
  props: {
    headers: Array,
    items: Array,
    nameTable: String,
    onEditAllNews: Boolean,
    onEdit: Boolean,
    onEditBudget: Boolean,
    onEditMeeting: Boolean,
    onEditSubMeeting: Boolean,
    onViewDataSubMeeting: Boolean,
    onViewMeeting: Boolean,
    onDelete: Boolean,
    onDeleteBudget: Boolean,
    onClickDeleteBudget: Function,
    onClickDelete: Function,
    viewUser: Function,
    onView: Boolean,
    typeSubcommittee: Boolean,
    onEditResearch: Boolean,
    onCheck: Boolean,
    // onViewCertificate: Boolean,
    // onCheckCertificate: Boolean,
    onCheckUser: Boolean,
    onReload: Boolean,
    onChangeStatus: Boolean,
    onAlign: Boolean,
    onViewData: Boolean,
    // onPostApprove: Boolean,
    onResearchApprove: Boolean,
    changeStatusMeeting: Function,
    typeConsideration: Function,
    editConsiderResult: Function,
    editCheckRF: Function,
    deleteRF: Function,
    viewCorresFile: Function,
    cancelResearchCode: Function,
    acceptCancel: Function,
    viewDatacancel: Function,
    onLeader: Boolean,
    onApprove: Function,
    onApproveRegen: Function,
    onMailSend: Function,
    onMailResend: Function,
    onSendMail: Function,
    editBudget: Function,
    EditUser: Function,
    VerifyReviewer: Function,
    onModal: Function,
    editParty: Function,
    delParty: Function,
    send: Function,
    onApproveRF: Function,
    verifyRF: Function,
    updateCertificate: Function,
    viewCertificate: Function,
    onViewToReviewerFiles: Function,
  },
  data: () => ({
    budgetDialog: false,
    isLoading: false,
    fullPage: true,
    budgetType: [
      {
        id: 0,
        name: "แหล่งทุนวิจัยภายนอก",
      },
      {
        id: 1,
        name: "แหล่งทุนวิจัยภายใน",
      },
    ],
  }),

  methods: {
    domain() {
      return domain
    },
    ...mapActions("User", ["getUserList"]),

    viewCer(url) {
      window.open(url);
    },
    // deleteRF() {
    //   Swal.fire({
    //     title: "คุณต้องการลบ\nเอกสารนี้ ใช่หรือไม่?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3E7662",
    //     cancelButtonColor: "rgb(189, 189, 189)",
    //     confirmButtonText: "ต้องการ",
    //     cancelButtonText: "ยกเลิก",
    //   })
    // },
    deleteUser(id) {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
      }).then((result) => {
        if (result.value) {
          console.log(id);
          this.$store
            .dispatch("Auth/delete", id)
            .then(() => {
              Swal.fire({
                title: "ลบข้อมูลเรียบร้อยแล้ว",
                icon: "success",
                position: "center",
                showConfirmButton: false,
                background: "#D8D8D8",
                timer: 1500,
              });
              this.onReload = false;
              setTimeout(() => {
                this.onReload = true;
              }, 1);
            })
            .catch((e) => {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "บันทึกไม่สำเร็จ",
                icon: "warning",
              });
            });
        }
      });
    },
    deleteBudget(id) {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
      }).then((result) => {
        if (result.value) {
          console.log(id);
          this.$store
            .dispatch("Budget/deleteBudget", id)
            .then(() => {
              Swal.fire({
                title: "ลบข้อมูลเรียบร้อยแล้ว",
                icon: "success",
                position: "center",
                showConfirmButton: false,
                timer: 1500,
              });
              this.onReload = false;
              setTimeout(() => {
                this.onReload = true;
              }, 1);
            })
            .catch((e) => {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "บันทึกไม่สำเร็จ",
                icon: "warning",
              });
            });
        }
      });
    },
    downloadPDF(item, name) {
      switch (name) {
        case "researchApprove":
          if (item.data.approveForm) {
            window.open(item.data.approveForm);
          } else {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text: "ไม่สามารถ download ไฟล์ได้",
              icon: "warning",
            });
          }
          break;
        case "postApprove":
          if (item.item.approveForm) {
            console.log(item.item);
            window.open(item.item.approveForm);
          } else {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text: "ไม่สามารถ download ไฟล์ได้",
              icon: "warning",
            });
          }
          break;
      }

    },
    onClickNewResearch(id) {
      let routeData = this.$router.resolve({
        name: "ViewResearch",
        query: { id: id, from: "researchAll" },
      });
      window.open(routeData.href, "_blank");
    },
    onClickAllResearch(id) {
      let routeData = this.$router.resolve({
        name: "ViewResearch",
        query: { id: id, from: "researchAll" },
      });
      window.open(routeData.href, "_blank");
    },
    onClickResearchHistory(id) {
      let routeData = this.$router.resolve({
        name: "ResearchHistory",
        query: { id: id, from: "researchAll" },
      });
      window.open(routeData.href, "_blank");
    },
    onClickViewVerifiedResearch(id) {
      let routeData = this.$router.resolve({
        name: "ViewResearch",
        query: { id: id, from: "VerifiedResearch" },
      });
      window.open(routeData.href, "_blank");
    },
    onClickView1(id) {
      let routeData = this.$router.resolve({
        name: "ViewResearch",
        query: { id: id },
      });
      window.open(routeData.href, "_blank");
    },
    onClickView2(id, userId) {
      let routeData = this.$router.resolve({
        name: "ViewResearch",
        query: { id: id, userID: userId, from: "ViewDataPostApprove" },
      });
      window.open(routeData.href, "_blank");
    },
    onClicktoViewDocument(id, userId, filter) {
      let routeData = this.$router.resolve({
        name: "FormResearch",
        query: { id: id, userID: userId, filter: filter},
      });
      window.open(routeData.href, "_blank");
    },
    onClickView4(id) {
      let routeData = this.$router.resolve({
        name: "ViewResearch",
        query: { id: id, name: "leader" },
      });
      window.open(routeData.href, "_blank");
    },
    onClickView7(id, link, rfID) {
      let routeData = this.$router.resolve({
        name: link,
        query: { id: id, name: "verify-rf", rfID: rfID },
      });
      window.open(routeData.href, "_blank");
    },
    onClickView8(id, link, rfID) {
      let routeData = this.$router.resolve({
        name: link,
        query: { id: id, name: "approve-rf", rfID: rfID },
      });
      window.open(routeData.href, "_blank");
    },
    onClickView9(id, link, rfID) {
      let routeData = this.$router.resolve({
        name: link,
        query: { id: id, name: "verify-rf", rfID: rfID },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
table th+th {
  border-left: 1px solid #dddddd;
}

table td+td {
  border-left: 1px solid #dddddd;
}

.table {
  th.text-center.sortable {
    font-weight: bold;
    font-size: 16px;
  }
}

.table {
  th.text-left.sortable {
    font-weight: bold;
    font-size: 16px;
  }
}

table thead tr th {
  text-align: center !important;
}

tbody tr td {
  color: #544a44;
}

table tbody tr td {
  text-align: left !important;
}

thead.v-data-table-header tr th {
  span {
    color: #000;
    font-size: 14px;
  }
}

.status-meeting:hover {
  text-decoration: underline;
}

.status-meeting-underline {
  text-decoration: underline;
}

.view-report {
  cursor: pointer;
}

.view-report:hover {
  color: #3e7662;
  font-weight: bold;
  text-decoration: underline;
}
</style>
